import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC } from 'react'

import { PhnxFooter } from './Footer'
import { ExtendedLinkField, FooterProps } from './Footer'

interface FooterBlokProps {
  blok: {
    disclaimer: SbBlokData[]
    copywrite: FooterProps['copy']
    socialMenu: FooterProps['socialMenu']
    desktopMenu: FooterProps['desktopMenu']
    mobileMenu: ExtendedLinkField[]
  } & SbBlokData
}

const Footer: FC<FooterBlokProps> = ({ blok }) => {
  // Simple transformation - just use the mobile menu data as-is from Storyblok
  // If an item has children, it will be collapsible
  // If it doesn't have children, it will be a simple link
  const transformedMobileMenu = blok.mobileMenu?.map((item: ExtendedLinkField) => {
    // Return the item exactly as it comes from Storyblok
    // The Footer component will handle collapsible logic based on item.items existence
    return item
  })

  return (
    <div {...storyblokEditable(blok)}>
      <PhnxFooter
        desktopMenu={blok.desktopMenu}
        socialMenu={blok.socialMenu}
        mobileMenu={transformedMobileMenu}
        disclaimer={
          blok.disclaimer != null
            ? blok.disclaimer.map((nestedBlok: SbBlokData) => (
                <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
              ))
            : undefined
        }
        copy={blok.copywrite}
      />
    </div>
  )
}

export default Footer
